import React from 'react';
import i18n from 'i18n';
import { Input } from 'modules/core/components/Input/Input';
import { DollarAdornment } from 'modules/core/components/Adornments';
import { FRONT_AND_BACK_ENDS_ADDS_FIELD_NAMES } from 'modules/RACAffordabilityEngine/const/fieldNames.const';
import { IField } from 'modules/core/types';

export const FRONT_AND_BACK_ADDS_FIELDS: IField[] = [
  {
    name: FRONT_AND_BACK_ENDS_ADDS_FIELD_NAMES.ADD_ONS,
    component: Input,
    label: i18n.t('components.frontAndBackEndsAddsModal.addOns'),
    isVerticalAlign: true,
    controlProps: {
      hideInitZeroValue: true,
      decimalScale: 0,
      placeholder: i18n.t('components.input.placeholders.integer'),
      startAdornment: <DollarAdornment />,
    },
  },
  {
    name: FRONT_AND_BACK_ENDS_ADDS_FIELD_NAMES.VSC,
    component: Input,
    label: i18n.t('components.frontAndBackEndsAddsModal.backEnd'),
    isVerticalAlign: true,
    controlProps: {
      hideInitZeroValue: true,
      decimalScale: 0,
      placeholder: i18n.t('components.input.placeholders.integer'),
      startAdornment: <DollarAdornment />,
    },
  },
  {
    name: FRONT_AND_BACK_ENDS_ADDS_FIELD_NAMES.GAP,
    component: Input,
    label: i18n.t('components.frontAndBackEndsAddsModal.gap'),
    isVerticalAlign: true,
    controlProps: {
      hideInitZeroValue: true,
      decimalScale: 0,
      placeholder: i18n.t('components.input.placeholders.integer'),
      startAdornment: <DollarAdornment />,
    },
  },
];
